module.exports = __webpack_public_path__ + "img/ic_circle_checked.96a433b3.svg";